import React from 'react';

interface ConfigurationStatusProps {
  provider: string;
  settings: any;
  requiredConfig: string[];
}

export const ConfigurationStatus: React.FC<ConfigurationStatusProps> = ({
  provider,
  settings,
  requiredConfig
}) => {
  const getMissingConfigs = () => {
    return requiredConfig.filter(configKey => {
      const value = settings[configKey];
      return !value || value.trim() === '' || value === 'sk-...' || value === 'gsk_...' || value === 'AKIA...';
    });
  };

  const missingConfigs = getMissingConfigs();
  const isConfigured = missingConfigs.length === 0;

  if (isConfigured) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-3">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-green-800">
              {provider} Configurado
            </h3>
            <p className="text-sm text-green-700">
              Todas as configurações necessárias foram fornecidas.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">
            Configuração Incompleta
          </h3>
          <div className="mt-2 text-sm text-yellow-700">
            <p className="mb-2">As seguintes configurações são necessárias:</p>
            <ul className="list-disc list-inside space-y-1">
              {missingConfigs.map((configKey) => (
                <li key={configKey} className="font-mono text-xs">
                  {configKey}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};



